import React, { FunctionComponent } from 'react';
import Button, { ButtonStyling } from 'components/button/button';
import CheckList from 'components/check-list/check-list';
import HeroTitle from 'components/hero-title/hero-title';
import Placard, { PlacardStyling } from 'components/placard/placard';
import StoreBadge, { StoreType } from 'components/store-badge/store-badge';
import { P1 } from 'components/typography';
import type { JoinHivesProps } from 'components/join-hives/join-hives';

const JoinHivesDesktop: FunctionComponent<JoinHivesProps> = ({
    title,
    text,
    bullets,
    cta,
    appStore,
    playStore,
}) => {
    return (
        <div className="join-hives-desktop">
            <Placard
                styling={PlacardStyling.FILLED_GRADIENT}
                content={
                    <div className="join-hives join-hives--desktop">
                        <div className="join-hives__left">
                            <HeroTitle text={title} />
                            <div className="join-hives__text">
                                <P1>{text}</P1>
                            </div>
                            <div className="join-hives__store-badges">
                                <StoreBadge
                                    type={StoreType.IOS}
                                    url={appStore.url}
                                    a11yText={appStore.text}
                                />
                                <StoreBadge
                                    type={StoreType.ANDROID}
                                    url={playStore.url}
                                    a11yText={playStore.text}
                                />
                            </div>
                            <div className="join-hives__cta">
                                <Button
                                    text={cta.text}
                                    href={cta.url}
                                    styling={ButtonStyling.CELL}
                                />
                            </div>
                        </div>
                        <div className="join-hives__right">
                            <CheckList items={bullets} />
                        </div>
                    </div>
                }
            />
        </div>
    );
};

export default JoinHivesDesktop;
